module.exports = __webpack_public_path__ + "img/red.e3c0940a.png";